import type { Backend } from './backend';

/**
 * The backend in use, for modules shared with the iPhone app (which picks its own backend). The web app sets it once
 * at start-up in data/store.
 */
export let backend: Backend = null as unknown as Backend;
export function setBackend(b: Backend) { backend = b; }
